<template>
  <div>
    <b-modal ref="passTypeUnavailableModal" :title="title" :ok-only="true">{{
      description
    }}</b-modal>
  </div>
</template>

<script>
export default {
  name: "PassTypeUnavailable",
  props: ["price", "title", "description", "start_date"],
  watch: {
    price() {
      this.showModal();
    },
    start_date() {
      this.showModal();
    }
  },
  methods: {
    showModal() {
      if (this.price === "unavailable") {
        //Show modal
        this.$refs.passTypeUnavailableModal.show();
      }
    }
  }
};
</script>
